import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Ethereal%20Japanese%20countryside%20at%20golden%20sunset%20hour%20with%20traditional%20shrine%20gate%20silhouette%20on%20hilltop%2C%20cherry%20blossom%20petals%20drifting%20in%20warm%20breeze%2C%20soft%20dreamy%20atmosphere%2C%20pastel%20golden%20and%20pink%20sky%2C%20nostalgic%20visual%20novel%20aesthetic%2C%20cinematic%20composition%2C%20emotional%20and%20bittersweet%20mood&width=1920&height=1080&seq=yosuga-hero-bg&orientation=landscape"
          alt="缘之空 - 奥木染町夏日黄昏"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-sparkling-line text-primary-300 text-sm"></i>
          <span className="text-xs text-background-50/90 font-medium">命运交织的感动</span>
        </div>
        <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-6">
          {siteInfo.fullName}
        </h1>
        <p className="text-base md:text-lg text-background-50/80 leading-relaxed max-w-2xl mx-auto mb-8">
          探索这部充满争议与感动的视觉小说——以细腻笔触描绘禁忌情感与命运羁绊，感受那跨越界限的纯粹情感冲击
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category?tab=剧情攻略"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            开始探索剧情攻略
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 md:gap-12 mt-14 max-w-lg mx-auto">
          {[
            { value: '200+', label: '原创文章' },
            { value: '8篇', label: '深度专题' },
            { value: '5万+', label: '忠实读者' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}